import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import { getRandomUUID } from "../../Token";
import { getBillingAccounts } from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import { handleApiError } from "../../global/utility/Utils";

function* fetchBillingAccountsData() {
  try {
    const response = yield axiosInstance.get(getBillingAccounts());
    const resData = response.data;
    if (response.status === 200) {
      yield put({
        type: "SET_BILLING_ACCOUNTS",
        billingAccounts: resData.currenttenancy.billingaccountids,
      });
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error_description;
    console.log("Error while getting Billing Account -> " + error);
    handleApiError("warning", errorMessage ? errorMessage : "Error getting Billing Account for the user, please reload the page.");
    return [];
  }
}

function* UserAccountSaga() {
  yield takeLatest("FETCH_BILLING_ACCOUNTS", fetchBillingAccountsData);
}

export default UserAccountSaga;
